import React,{useState,useEffect} from 'react';
import './Search.css';
import Header2 from '../Header2';
import {Link} from 'react-router-dom'

const baseUrl = "https://zomato-big-assignment-2-production.up.railway.app"
const blaUrl=process.env.REACT_APP_API_URL;


const Search = () => {

    const [title] = useState(' Cafelicious');
    const [subtitle] = useState('World Of Cafes At Your Fingertips');
    const [location,setLocation] = useState([]);
    const [restaurant,setRestaurant] = useState([]);
    const [selectedValue, setSelectedValue] = useState('');
    
    useEffect(() => {
        fetch(`${baseUrl}/location`,{method:'GET'})
        .then((res) =>  res.json())
        .then((data) => {
            setLocation(data);

        })
    },[])






// <Link className='btn btn-danger'
// to={`/listing/${foodTypeId}`}>
//     Back
// </Link> &nbsp;&nbsp;


    const renderCity = (data) => {
        if(data){
            return data.map((item) => {
                return(
                    <option key={item.state_id} value={item.state_id}>
                        {item.state}
                    </option>
                )
            })
        }
    }


    const handleCity = (event) => {
        console.log(event.target.value);
        let stateId = event.target.value;
        fetch(`${baseUrl}/restaurants?stateId=${stateId}`,{method:'GET'})
        .then((res) => res.json())
        .then((data) => {
            setRestaurant(data)
        })
    }



        const handleSelectChange = (event) => {
            setSelectedValue(event.target.value);
          };


    




    const renderRestaurant = (data) => {
        if(data){
            return data.map((item) => {
                return(
                    <>
 
                    <option key={item.restaurant_id} value={item.restaurant_id}>
                        {item.restaurant_name} | {item.address}
                    </option>
                    </>
                )
            })
        }

    }




 
    return(
        <div id="search">
            <Header2/>
           <div className="logo">
               <span><div id="zomatologocontainer"><img id="zomatologo" src="./cafelicious circle crop.png"></img></div></span>   
           </div>

           <div id="heading">
              {title}
                <div id="subheading">
                    {subtitle}
                </div>
           </div>

           <div className="dropdown">
                <select onChange={handleCity} className="selectstyle bg-white text-black p-3 rounded-lg shadow-lg mr-2">
                   <option>-----SELECT YOUR CITY-----</option>
                   {renderCity(location)}
                </select>
                <select className="selectstyle bg-white text-black p-3 rounded-lg shadow-lg ml-2" onChange={handleSelectChange}>
                    <option>-----SELECT YOUR RESTAURANTS-----</option>
                    {renderRestaurant(restaurant)}
                </select>

                <Link to={`/details?restId=${selectedValue}`}>
                        <button className="gobutton">
                             Go
                        </button>
                </Link>

           </div>
        </div>
    )
}

export default Search;
